import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { MasterDataDTO } from '../../api/plyca-dtos';
import { CompanyDTO, SubcontratedCompanyDTO } from '../../api/plyca-dtos-v2';
import { formElementComponent } from '../../components/forms/formElement.component';

@Injectable()
export class RegisterContractModificationValidations {

  private static isNoTax(model: any) {
    let noTax = (model && model.contractModification && model.contractModification.budget &&
      model.contractModification.budget.registerTaxType &&
      model.contractModification.budget.registerTaxType.identifier === '0<>TIPO_IMPUESTO');
    return noTax;
  }

  constructor() { }


  // Habilitar: Tipo Impositivo
  public enabledTaxRate(model: any) {
    let noTax = RegisterContractModificationValidations.isNoTax(model);
    return !noTax;
  }

  public isVisibleBudgetRegisterTaxRate(model: any) {
    let isTaxRate = model.contractModification.budget && model.contractModification.budget.registerTaxType && model.contractModification.budget.registerTaxType.identifier && model.contractModification.budget.registerTaxType.identifier == '998<>TIPO_IMPUESTO';
    if (isTaxRate) {
      return true;
    }
    return false;
  }

  public isVisibleBudgetAuxTaxRate(model: any) {
    let isTaxRate = model.contractModification.budget && model.contractModification.budget.auxTaxType && model.contractModification.budget.auxTaxType.identifier && model.contractModification.budget.auxTaxType.identifier == '998<>TIPO_IMPUESTO';
    if (isTaxRate) {
      return true;
    }
    return false;
  }

  public isVisibleDOUEPublicationDate(model: any) {
    if (model.contractModification.plannedPeriod && model.contractModification.plannedPeriod.douePublication) {
      return true;
    } else {
      return false;
    }
  }

  public isVisibleNotPlannedPCAPCause(model: any) {
    if (model.contractModification.cause && model.contractModification.cause.generalCause && model.contractModification.cause.generalCause.identifier == "000130<>CAUSAS_INCIDENCIA") {
      return true;
    }
    return false;
  }

  public isContractorCuase(model: any) {
    if (model.contractModification && model.contractModification.type && model.contractModification.type.identifier == '0<>TIPO_AMPLIACION') {
      return true;
    } else {
      return false;
    }
  }

  public isEntrepreneurCause(model: any) {
    if (model.contractModification && model.contractModification.type && model.contractModification.type.identifier == '1<>TIPO_AMPLIACION') {
      return true;
    } else {
      return false;
    }
  }

  public causeAttributableToContractor(model: any) {
    if (model.contractModification && model.contractModification.type && model.contractModification.type.identifier == '0<>TIPO_AMPLIACION') {
      return false;
    } else {
      return true;
    }
  }

  public clearExtensionData(model: any) {
    model.contractModification.plannedPeriod.durationMonth = undefined;
    model.contractModification.cause.description = '';
  }

  public isVisibleRegisterData(model: any) {
    if (model.contractModification.registerNumber && model.contractModification.plannedPeriod.registerDate) {
      return true;
    } else {
      return false;
    }
  }

  public isVisibleRegisterDataLvto(model: any) {
    if (model.contractModification.registerLiftingNumber && model.contractModification.plannedPeriod.registerLiftingDate) {
      return true;
    } else {
      return false;
    }
  }

  public static isAyto(model: any) {
    if (model.contract && model.contract.context && model.contract.context.configurations) {
      if (model.contract.context.configurations.isPanap.value || model.contract.context.configurations.isNoPanap.value) {
        return false;
      }
      return true;
    }
  }

  public isCBAM(model: any) {
    let isCBAM = false;
    if (model.context && model.context.configurations && model.context.configurations.isCBAM) {
      isCBAM = model.context.configurations.isCBAM.value;
    }
    return isCBAM;
  }

  public isVisibleInAMAndCSC(model: any) {
    let isVisibleInAM = false;
    if (model.contractModification.alias == 'CSC') {
      isVisibleInAM = true;
      if (RegisterContractModificationValidations.isAM(model)) {
        isVisibleInAM = false;
      }
    }
    return isVisibleInAM;
  }

  public isVisibleInAMAndMDCAndPRC(model: any) {
    let isVisibleInAM = true;
    if (RegisterContractModificationValidations.isAM(model) && (model.contractModification.alias == 'MDC' || model.contractModification.alias == 'PRC')) {
      isVisibleInAM = false;
    }
    return isVisibleInAM;
  }


  public static isAM(model: any) {
    let isAM = false;
    if (model.context && model.context.configurations && model.context.configurations.isAM) {
      isAM = model.context.configurations.isAM.value;
    }
    return isAM;
  }

  private static isProjectReplyca(model: any) {
    let isProjectReplyca = false;
    if (model.context && model.context.configurations && model.context.configurations.isProjectReplyca) {
      isProjectReplyca = model.context.configurations.isProjectReplyca.value;
    }
    return isProjectReplyca;
  }

  public isProjectReplyca(model: any) {
    return RegisterContractModificationValidations.isProjectReplyca(model);
  }
  /*public isVisibleBudgetAccountLines(model: any) {
    let isVisibleBudgetAccountLines = RegisterContractModificationValidations.isAM(model);
    let isEntityPanap = RegisterContractModificationValidations.isEntityPanap(model);
    let isEntityNoPanap = RegisterContractModificationValidations.isEntityNoPanap(model);
    return !(isAM && (isEntityPanap || isEntityNoPanap));
  }*/

  public static isEntityPanap(model: any) {
    let isPanap = false;
    if (model.contract && model.contract.context && model.contract.context.configurations && model.contract.context.configurations.isPanap) {
      isPanap = model.contract.context.configurations.isPanap.value;
    }
    return isPanap;
  }

  public static isEntityNoPanap(model: any) {
    let isNoPanap = false;
    if (model.contract && model.contract.context && model.contract.context.configurations && model.contract.context.configurations.isNoPanap) {
      isNoPanap = model.contract.context.configurations.isNoPanap.value;
    }
    return isNoPanap;
  }


  public isVisibleAuxAmount(model: any) {
    return (model.contractModification.alias == 'MDC');
  }

  public isVisibleBudgetVariation(model: any) {
    return (model.contractModification.alias == 'MDC' || model.contractModification.alias == 'PRC');
  }

  public isMDC(model: any) {
    return (model.contractModification.alias == 'MDC');
  }

  public isPRC(model: any) {
    return (model.contractModification.alias == 'PRC');
  }

  public isLvto(model: any) {
    return model.liftingContractModification;
  }

  public isCSC(model: any) {
    return (model.contractModification.alias == 'CSC');
  }

  //Visibilidad de la tabla de anualidades.
  /*public isVisibleBudgetAccountLines(model: any) {
    let isAM = RegisterContractModificationValidations.isAM(model);
    let isEntityPanap = RegisterContractModificationValidations.isEntityPanap(model);
    let isEntityNoPanap = RegisterContractModificationValidations.isEntityNoPanap(model);
    return !(isAM && (isEntityPanap || isEntityNoPanap));
  }*/

  //Visibilidad de la tabla de anualidades.
  public isVisibleDOUEData(model: any) {
    //let isEntityPanap = RegisterContractModificationValidations.isEntityPanap(model);
    let isEntityNoPanap = RegisterContractModificationValidations.isEntityNoPanap(model);
    return !isEntityNoPanap;
  }


  //La organica se ve siempre, a no ser que sea ingreso (FICHAREPLYCA.TIPO_MOV_CONTABLE)
  public isVisibleOrganic(model: any) {
    let visible = true;
    if (model.contractInfo && model.contractInfo.accountingMotivation && model.contractInfo.accountingMotivation.identifier == '2<>TIPO_MOTIVACION_CONTABLE') {
      visible = false;
    }
    return visible;
  }

  //Programa y economico, solo se ven para ayto a no ser que sea ingreso (FICHAREPLYCA.TIPO_MOV_CONTABLE). En PANAP y NOPANAP no se ven.
  public isVisibleFunctionalEconomic(model: any) {
    let visible = true;
    if (RegisterContractModificationValidations.isAyto(model)) {
      if (model.contractInfo && model.contractInfo.accountingMotivation && model.contractInfo.accountingMotivation.identifier == '2<>TIPO_MOTIVACION_CONTABLE') {
        visible = false;
      }
    } else {
      //es panap O NO PANAP
      visible = false;
    }
    return visible;
  }

  //La organica se ve siempre, a no ser que sea ingreso (FICHAREPLYCA.TIPO_MOV_CONTABLE)
  public isVisibleOrganicEditorConfig(model: any) {
    if (model._parent.contractInfo && model._parent.contractInfo.accountingMotivation && model._parent.contractInfo.accountingMotivation.identifier == '2<>TIPO_MOTIVACION_CONTABLE') {
      return false;
    }
    return true;
  }

  //Programa y economico, solo se ven para ayto a no ser que sea ingreso (FICHAREPLYCA.TIPO_MOV_CONTABLE). En PANAP y NOPANAP no se ven.
  public isVisibleFunctionalEconomicEditorConfig(model: any) {
    if (RegisterContractModificationValidations.isAyto(model._parent)) {
      if (model._parent.contractInfo && model._parent.contractInfo.accountingMotivation && model._parent.contractInfo.accountingMotivation.identifier == '2<>TIPO_MOTIVACION_CONTABLE') {
        return false;
      }
    } else {
      //es panap O NO PANAP
      return false;
    }
    return true;
  }

  public isVisibleAmountsBudgetAccountLines(model: any) {
    let visible = true;
    visible = !RegisterContractModificationValidations.isAM(model);
    return visible;
  }

  public isVisibleAmountsBudgetAccountLinesEditorConfig(model: any) {
    let visible = true;
    visible = !RegisterContractModificationValidations.isAM(model._parent);
    return visible;
  }

  public visibleTaxRateType(model: any) {
    //Para que sea visible, buscamos alguno que sea de tipo 998
    let visible = false;
    if (model && model.budgetAccountLines) {
      for (let element of model.budgetAccountLines) {


        // model.budgetAccountLines.forEach(element => {
        if (element && element.budget && element.budget.taxType) {
          visible = element.budget.taxType.identifier == '998<>TIPO_IMPUESTO';
          if (visible) {
            break;
          }
        }
      };
    }
    return visible;
  }

  //Incidencia penalidad
  public clearPenaltyData(model: any) {
    if (RegisterContractModificationValidations.isProjectReplyca(model)) {
      if (model.contractModification && model.contractModification.type && model.contractModification.type.identifier == '0<>TIPO_PENALIDAD') {
        model.contractModification.plannedPeriod.delateDays = null;
        model.contractModification.budget.amountDay = null;
        model.contractModification.budget.auxAmount = null;
      } else {
        //model.contractModification.cause = null;
        model.contractModification.budget.registerTotalAmount = null;
      }
    }
  }

  public isDelayExecution(model: any) {
    if (model.contractModification && model.contractModification.type && model.contractModification.type.identifier == '0<>TIPO_PENALIDAD') {
      return true;
    } else {
      return false;
    }
  }

  public isOtherBreach(model: any) {
    if (model.contractModification && model.contractModification.type && model.contractModification.type.identifier == '1<>TIPO_PENALIDAD') {
      return true;
    } else {
      return false;
    }
  }

  getPenaltyType(model: any) {
    let type;
    if (RegisterContractModificationValidations.isProjectReplyca(model)) {
      //Si es repluca, retornamos el type
      type = model.contractModification.type;
    } else {
      //Si es automatica, tenemos que consultar un campo, obligatorio en la fi
      if (model.contractModification && model.contractModification.plannedPeriod && model.contractModification.plannedPeriod.delateDays && model.contractModification.plannedPeriod.delateDays != 0) {
        type = new MasterDataDTO('0', 'TIPO_PENALIDAD');
      } else {
        type = new MasterDataDTO('1', 'TIPO_PENALIDAD');
      }
    }
    return type;
  }

  public getAuxAmountCSC(model: any) {
    //En las FRCFI manuales, este campo se calcula con la suma del importe sin iva mas el importe impuestos, y no es editable.
    //En las FRCFI automaticas, es no editable tambien, pero viene precargado con el valor de la FI.
    //- En la FI, este importe no esta desglosado.
    //- Al llegar a la FRCFI web, con el campo precargado y no editable, no tiene que modificarse su valor con la suma del desglose.
    //- Se debe validar que el importe coincida con el desglose, para que se modifiquen en caso de que no coincidan.
    let auxAmount = 0;
    if (RegisterContractModificationValidations.isProjectReplyca(model)) {
      //Manuales: sumatorio.
      if (model.contractModification.budget != null && model.contractModification.budget.auxTotalTaxes != null && model.contractModification.budget.auxTotalTaxes != 0.0) {
        auxAmount = model.contractModification.budget.auxAmountExcludingTaxes + model.contractModification.budget.auxTotalTaxes;
      } else {
        auxAmount = model.contractModification.budget.auxAmountExcludingTaxes;
      }
    } else {
      //Automaticas: retornamos el valor sin sumatorio.
      if (model.contractModification.budget != null && model.contractModification.budget.auxAmount != null) {
        auxAmount = model.contractModification.budget.auxAmount;
      }
    }
    return auxAmount;
  }


  public contractorResponability(model: any) {
    return (model.contractModification.contractorResponability != null && model.contractModification.contractorResponability);
  }

  public existDisqualification(model: any) {
    return (model.contractModification.disqualification != null && model.contractModification.disqualification);
  }

  public addEspecificCauses(model: any) {
    let addEspecificCauses = false;
    if (RegisterContractModificationValidations.isProjectReplyca(model)) {
        if (model.ui.enabledEspecificCauseslist !== undefined) {
          const especificCausesArray = model.ui.enabledEspecificCauseslist.split(';');
          especificCausesArray.forEach(element => {
              if (model.contractModification.cause !== undefined &&
                model.contractModification.cause.generalCauses !== undefined) {
                  model.contractModification.cause.generalCauses.forEach(cause => {
                      const causeParts = cause.identifier.split('<>');
                      const causeId = causeParts[0].trim();
                      if (causeId === element) {
                          addEspecificCauses = true;
                          return;
                      }
                  });
              }
          });
      }
    } else {
        addEspecificCauses = model.contractModification.cause !== undefined && model.contractModification.cause.specificCause !== undefined;
    }
    return addEspecificCauses;
  }

  /*public addOtherCauses(model: any) {
    if (RegisterContractModificationValidations.isProjectReplyca(model)) {
      if (model.ui.enabledOtherCausesList !== undefined) {
        let otherCausesArray = model.ui.enabledOtherCausesList.split(";");
        otherCausesArray.forEach(element => {
          if (model.contractModification.cause != undefined && model.contractModification.cause.generalCause !== undefined) {
            let generalCauseId = model.contractModification.cause.generalCause.properties.CAUSAID;
            if (generalCauseId === element) {
              addOtherCauses = true;
              return addOtherCauses;
            }
          }
        });
      }
    } else {
      addOtherCauses = model.contractModification.cause !== undefined && model.contractModification.cause.description !== undefined;
    }
    return addOtherCauses;
  }*/


    public addOtherCauses(model: any): boolean {
      let addOtherCauses = false;

      if (RegisterContractModificationValidations.isProjectReplyca(model)) {
          if (model.ui.enabledOtherCausesList !== undefined) {
              const otherCausesArray = model.ui.enabledOtherCausesList.split(';');
              otherCausesArray.forEach(element => {
                  if (model.contractModification.cause !== undefined &&
                    model.contractModification.cause.generalCauses !== undefined) {
                      model.contractModification.cause.generalCauses.forEach(cause => {
                          const causeParts = cause.identifier.split('<>');
                          const causeId = causeParts[0].trim();
                          if (causeId === element) {
                              addOtherCauses = true;
                              return;
                          }
                      });
                  }
              });
          }
      } else {
          if (model.contractModification.cause !== undefined) {
            addOtherCauses = model.contractModification.cause !== undefined && model.contractModification.cause.description !== undefined;
          }
      }
      return addOtherCauses;
  }


  public isEditableEditorConfigSCN(model: any) {
    // "editable": "($functions.isProjectReplyca && this.model.ui.edition)  || this.model.ui.isEditableSupport"
    if (model._parent !== undefined && model._parent.ui !== undefined) {
      let isProjectReplyca = RegisterContractModificationValidations.isProjectReplyca(model._parent);
      return ((isProjectReplyca && model._parent.ui.edition) || model._parent.ui.isEditableSupport);
    }
    return false;
  }


  public enabledAddRemoveRowsSCN(model: any) {
    //"editable": "($functions.isProjectReplyca && this.model.ui.edition)  || this.model.ui.isEditableSupport"
    if (model !== undefined && model.ui !== undefined) {
      let isProjectReplyca = RegisterContractModificationValidations.isProjectReplyca(model);
      return ((isProjectReplyca && model.ui.edition) || model.ui.isEditableSupport);
    }
    return false;
  }

  public updatePymeSCN(model: any) {
    if (model !== undefined && model.company !== undefined) {
      model.name = model.company.name;
    } else {
      model.name = ' ';
    }
    if (model ?.company ?.customFields && model ?.company.customFields !== undefined) {
      if (model ?.company.customFields.EMP_TIPO_PYME !== undefined) {
        model.pymeType = model ?.company.customFields.EMP_TIPO_PYME;
      } else {
        model.pymeType = undefined;
      }
      if (model.company.customFields.EMP_ES_PYME_STD.identifier === '1<>nulo') {
        model.sme = true;
      } else {
        model.sme = false;
      }
    } else {
      model.sme = undefined;
      model.pymeType = undefined;
    }
  }

  private static isApplicableLegislationLCSP_09(model: any) {
    let isApplicableLegislationLCSP_09 = false;
    if (model.context && model.context.configurations && model.context.configurations.isApplicableLegislationLCSP_09) {
      isApplicableLegislationLCSP_09 = model.context.configurations.isApplicableLegislationLCSP_09.value;
    }
    return isApplicableLegislationLCSP_09;
  }

  public isApplicableLegislationLCSP_09(model: any) {
    return RegisterContractModificationValidations.isApplicableLegislationLCSP_09(model);
  }


  public visibleContractExtension(model: any) {
    let isApplicableLegislationLCSP_09 = RegisterContractModificationValidations.isApplicableLegislationLCSP_09(model);
    let isCBAM = false;
    if (model.context && model.context.configurations && model.context.configurations.isCBAM) {
      isCBAM = model.context.configurations.isCBAM.value;
    }
    let visible = isApplicableLegislationLCSP_09 && !isCBAM;
    return visible;
  }

  public editableDurationMonthPRC(model: any) {
    let editable = false;
    //          "editable": "($functions.isProjectReplyca && this.model.ui.edition)  || this.model.ui.isEditableSupport",
    if (model !== undefined && model.ui !== undefined) {
      let isProjectReplyca = RegisterContractModificationValidations.isProjectReplyca(model);
      if (isProjectReplyca) {
        editable = (isProjectReplyca && model.ui.edition) || model.ui.isEditableSupport;
      } else {
        editable = model.contractModification?.contractExtension && model.contractModification?.contractExtension.identifier === '1<>TIPO_PRORROGA';
      }
    }
    return editable;
  }


  //Se ha seleccionado el hito desde el buscador porque existe mas de un origen
  public changeProjectOrganizationalSnapshot(model: any) {
    if (model.ui.selectedProjectOrganizationalSnapshot) {
      model.projectOrganizationalSnapshot.promoterOrganizationalUnitName = model.ui.selectedProjectOrganizationalSnapshot.content.UD_PROMOTORA_DESCRIP.value;
      model.projectOrganizationalSnapshot.promoterOrganizationalUnitHex = model.ui.selectedProjectOrganizationalSnapshot.content.UD_PROMOTORA_ID.value;
      model.projectOrganizationalSnapshot.contractorOrganizationalUnitName = model.ui.selectedProjectOrganizationalSnapshot.content.UD_CONTRATADORA_DESCRIP.value;
      model.projectOrganizationalSnapshot.contractorOrganizationalUnitHex = model.ui.selectedProjectOrganizationalSnapshot.content.UD_CONTRATADORA_ID.value;
      model.projectOrganizationalSnapshot.fundsCenterDescription = model.ui.selectedProjectOrganizationalSnapshot.content.CENTRO_GESTOR_DESCRIP.value;
      model.projectOrganizationalSnapshot.fundsCenter = model.ui.selectedProjectOrganizationalSnapshot.content.CENTRO_GESTOR_ID.value;
      model.projectOrganizationalSnapshot.contractorInboxName = model.ui.selectedProjectOrganizationalSnapshot.content.ORG_CONTRATACION_DESCRIP.value;
      model.projectOrganizationalSnapshot.contractorInboxId = model.ui.selectedProjectOrganizationalSnapshot.content.ORG_CONTRATACION_ID.value;
    } else {
      //La unidad promotora no tiene valor.
      model.projectOrganizationalSnapshot.contractorOrganizationalUnitName = undefined;
      model.projectOrganizationalSnapshot.contractorOrganizationalUnitHex = undefined;
      model.projectOrganizationalSnapshot.fundsCenterDescription = undefined;
      model.projectOrganizationalSnapshot.fundsCenter = undefined;
      model.projectOrganizationalSnapshot.promoterOrganizationalUnitName = undefined;
      model.projectOrganizationalSnapshot.promoterOrganizationalUnitHex = undefined;
      model.projectOrganizationalSnapshot.contractorInboxName = undefined;
      model.projectOrganizationalSnapshot.contractorInboxId = undefined;
    }
  }

  //LVTO: Se ha seleccionado el hito desde el buscador porque existe mas de un origen
  public changeLiftingProjectOrganizationalSnapshot(model: any) {
    if (model.ui.selectedLiftingProjectOrganizationalSnapshot) {
      model.liftingProjectOrganizationalSnapshot.promoterOrganizationalUnitName = model.ui.selectedLiftingProjectOrganizationalSnapshot.content.UD_PROMOTORA_DESCRIP.value;
      model.liftingProjectOrganizationalSnapshot.promoterOrganizationalUnitHex = model.ui.selectedLiftingProjectOrganizationalSnapshot.content.UD_PROMOTORA_ID.value;
      model.liftingProjectOrganizationalSnapshot.contractorOrganizationalUnitName = model.ui.selectedLiftingProjectOrganizationalSnapshot.content.UD_CONTRATADORA_DESCRIP.value;
      model.liftingProjectOrganizationalSnapshot.contractorOrganizationalUnitHex = model.ui.selectedLiftingProjectOrganizationalSnapshot.content.UD_CONTRATADORA_ID.value;
      model.liftingProjectOrganizationalSnapshot.fundsCenterDescription = model.ui.selectedLiftingProjectOrganizationalSnapshot.content.CENTRO_GESTOR_DESCRIP.value;
      model.liftingProjectOrganizationalSnapshot.fundsCenter = model.ui.selectedLiftingProjectOrganizationalSnapshot.content.CENTRO_GESTOR_ID.value;
      model.liftingProjectOrganizationalSnapshot.contractorInboxName = model.ui.selectedLiftingProjectOrganizationalSnapshot.content.ORG_CONTRATACION_DESCRIP.value;
      model.liftingProjectOrganizationalSnapshot.contractorInboxId = model.ui.selectedLiftingProjectOrganizationalSnapshot.content.ORG_CONTRATACION_ID.value;
    } else {
      //La unidad promotora no tiene valor.
      model.liftingProjectOrganizationalSnapshot.contractorOrganizationalUnitName = undefined;
      model.liftingProjectOrganizationalSnapshot.contractorOrganizationalUnitHex = undefined;
      model.liftingProjectOrganizationalSnapshot.fundsCenterDescription = undefined;
      model.liftingProjectOrganizationalSnapshot.fundsCenter = undefined;
      model.liftingProjectOrganizationalSnapshot.promoterOrganizationalUnitName = undefined;
      model.liftingProjectOrganizationalSnapshot.promoterOrganizationalUnitHex = undefined;
      model.liftingProjectOrganizationalSnapshot.contractorInboxName = undefined;
      model.liftingProjectOrganizationalSnapshot.contractorInboxId = undefined;
    }
  }

  public loadOrganizationalSnapshotData(model: any) {    //Limpiamos los datos de la pantalla
    model.projectOrganizationalSnapshot.contractorOrganizationalUnitName = undefined;
    model.projectOrganizationalSnapshot.contractorOrganizationalUnitHex = undefined;
    model.projectOrganizationalSnapshot.fundsCenterDescription = undefined;
    model.projectOrganizationalSnapshot.fundsCenter = undefined;
    model.projectOrganizationalSnapshot.promoterOrganizationalUnitName = undefined;
    model.projectOrganizationalSnapshot.promoterOrganizationalUnitHex = undefined;
    model.projectOrganizationalSnapshot.contractorInboxName = undefined;
    model.projectOrganizationalSnapshot.contractorInboxId = undefined;
    //Si hemos seleccionado valor en el combo. Si no tiene valor viene con undefined o con null....¿?¿?
    if (model.contractModification.previousOrganizationalUnitRegistration !== undefined && model.contractModification.previousOrganizationalUnitRegistration !== null) {
      if (model.contractModification.previousOrganizationalUnitRegistration) {
        //Se ha seleccionado SI. Comprobamos si tiene cargado el origen (ya viene de servidor con todo ok). Si no, no cargamos nada, tienen que buscarlo.
        if (model.originProjectOrganizationalSnapshot !== undefined) {
          model.projectOrganizationalSnapshot = JSON.parse(JSON.stringify(model.originProjectOrganizationalSnapshot));
        }
      } else {
        //Se ha seleccinado NO. Cargamos el ultimo destino. Ya viene de servidor con todo ok.
        model.projectOrganizationalSnapshot = JSON.parse(JSON.stringify(model.lastDestinationProjectOrganizationalSnapshot));;
      }
      model.ui.selectedProjectOrganizationalSnapshot = model.projectOrganizationalSnapshot;
    }
  }

  //LVTO
  public loadLiftingOrganizationalSnapshotData(model: any) {    //Limpiamos los datos de la pantalla
    model.liftingProjectOrganizationalSnapshot.contractorOrganizationalUnitName = undefined;
    model.liftingProjectOrganizationalSnapshot.contractorOrganizationalUnitHex = undefined;
    model.liftingProjectOrganizationalSnapshot.fundsCenterDescription = undefined;
    model.liftingProjectOrganizationalSnapshot.fundsCenter = undefined;
    model.liftingProjectOrganizationalSnapshot.promoterOrganizationalUnitName = undefined;
    model.liftingProjectOrganizationalSnapshot.promoterOrganizationalUnitHex = undefined;
    model.liftingProjectOrganizationalSnapshot.contractorInboxName = undefined;
    model.liftingProjectOrganizationalSnapshot.contractorInboxId = undefined;
    //Si hemos seleccionado valor en el combo. Si no tiene valor viene con undefined o con null....¿?¿?
    if (model.contractModification.liftingPreviousOrganizationalUnitRegistration !== undefined && model.contractModification.liftingPreviousOrganizationalUnitRegistration !== null) {
      if (model.contractModification.liftingPreviousOrganizationalUnitRegistration) {
        //Se ha seleccionado SI. Comprobamos si tiene cargado el origen (ya viene de servidor con todo ok). Si no, no cargamos nada, tienen que buscarlo.
        if (model.originProjectOrganizationalSnapshot !== undefined) {
          model.liftingProjectOrganizationalSnapshot = JSON.parse(JSON.stringify(model.originProjectOrganizationalSnapshot));
        }
      } else {
        //Se ha seleccinado NO. Cargamos el ultimo destino. Ya viene de servidor con todo ok.
        model.liftingProjectOrganizationalSnapshot = JSON.parse(JSON.stringify(model.lastDestinationProjectOrganizationalSnapshot));;
      }
      model.ui.selectedLiftingProjectOrganizationalSnapshot = model.liftingProjectOrganizationalSnapshot;
    }
  }

  public visiblePreviousOrganizationalUnitRegistration(model: any) {
    let isLVTO = model.liftingContractModification;
    let activeTemporayPeriodOrganizationalChange = model.ui.activeTemporayPeriodOrganizationalChange;
    return !isLVTO && (activeTemporayPeriodOrganizationalChange || (!activeTemporayPeriodOrganizationalChange && model.contractModification.previousOrganizationalUnitRegistration !== undefined));
  }


  public visibleLiftingPreviousOrganizationalUnitRegistration(model: any) {
    let activeTemporayPeriodOrganizationalChange = model.ui.activeTemporayPeriodOrganizationalChange;
    return activeTemporayPeriodOrganizationalChange || (!activeTemporayPeriodOrganizationalChange && model.contractModification.liftingPreviousOrganizationalUnitRegistration !== undefined);
  }


}
